module.exports = __webpack_public_path__ + "img/摄图网_500500411_banner_app（非企业商用）.83d8a462.png";